import React, {PropTypes} from 'react';
import axios from '../../../../constants/axios';
import {IndexLink, Link} from 'react-router';
import {Button, Table} from 'react-bootstrap';
import moment from 'moment';
import debounce from 'lodash/debounce';
import alert from 'alertify.js';
import classname from 'classnames';

import './SaleInvoiceDetail.less';

class SaleInvoiceDetail extends React.Component {

   constructor(props) {
      super(props);
      this.state = {
         invoiceDetails: {},
         loading: false,
         deliveryCharge: false,
         overWeightCharge: false,
         time: moment().format('DD.MM.YYYY hh:mm A'),
         showPreviousDue: true,
      };
   }


   componentDidMount() {
      this.interval = setInterval(() => {
         this.setState({
            time: moment().format('DD.MM.YYYY hh:mm A'),
         });
      }, 5000);
      this.loadInvoiceDetails();
   }

   componentWillUnmount() {
      clearInterval(this.interval);
   }

   sendDetailBySMS = () => {
      const {invoiceId} = this.props.params;
      this.setState({
         loading: true,
      });
      axios.post(`inventorySales/sendInvoiceDetailsSMSById`, {
         invoiceId
      })
         .then((res) => {
            if(res.status === 201){
               alert.success(res.data);
            }else{
               alert.error(res.data);
            }
            this.setState({
               loading: false,
            });
         });
   };

   loadInvoiceDetails = () => {
      const {invoiceId} = this.props.params;
      this.setState({
         loading: true,
      });
      axios.get(`inventorySales/getInvoiceDetailsById/${invoiceId}`)
         .then((res) => {
            this.setState({
               invoiceDetails: res.data,
               loading: false,
            });
         });
   };

   inputChangeHandler = (e) => {
      this.setState({
         [e.target.name]: !this.state[e.target.name]
      });
   };

   billAgainstThisInvoice = () => {
      const {invoiceId} = this.props.params;

      axios.put(`inventorySales/billAgainstInvoiceId/${invoiceId}`)
         .then((res) => {
            if (res.status === 201) {
               this.loadInvoiceDetails();
               alert.success('Billed. Now, Receive Money.');
            } else {
               alert.error("Something Not Expected. Call Rasel");
            }
         })
         .catch((err) => {
            alert.error(err.response.data);
         });
   };

   adjustPaymentFromPrepaid = () => {
      const {invoiceId} = this.props.params;
      axios.post(`inventorySales/adjustPaymentFromPrepaid/${invoiceId}`)
         .then((res) => {
            if (res.status === 201) {
               this.loadInvoiceDetails();
               alert.success('Billed. Now, Receive Money.');
            } else {
               alert.error("Something Not Expected. Call Rasel");
            }
         })
         .catch((err) => {
            alert.error(err.response.data);
         });
   };

   printPage = () => {
      window.print();
   };

   render() {
      const {invoiceDetails, loading, time, showPreviousDue} = this.state;
      const getTotalDue = function () {
         if (invoiceDetails.otherDueInvoices.length <= 0) {
            return 0;
         } else {
            return invoiceDetails.otherDueInvoices.reduce((sum, i) => sum + i.due, 0).toFixed(2);
         }
      };
      return (
         <div>
            <div className="SaleInvoiceDetail">
               <div className="mart71_info">
                  <h1>Mart71.com</h1>
                  <h1>01910 717171, 01519 717171</h1>
               </div>
               <h4>Sale Invoice Detail</h4>
               {
                  loading
                     ?
                     <div>Loading...</div>
                     :
                     <div className="row SaleInvoiceDetail_info_address">
                        <div className="col-md-6">

                           <p>InvoiceId: {invoiceDetails.id}</p>
                           <p className={classname({
                              'text-success': true,
                              hideOnPrint: invoiceDetails.contact_id === 5
                           })}
                           >
                              নাম: {invoiceDetails.contact_name}</p>
                           <p className={classname({
                              'text-success': true,
                              hideOnPrint: invoiceDetails.contact_id === 5
                           })}>
                              মোবাইল: {invoiceDetails.contact_mobile}</p>
                           <div className="ems_price_info">
                              {/*shoing on ems*/}
                              <p>Item Amount: {invoiceDetails.total_amount}</p>
                              <p>Paid Amount: {invoiceDetails.paid_amount}</p>
                              <p>Pre Paid Amount: {invoiceDetails.prepaid_amount}</p>
                              <p>Due: {invoiceDetails.due}</p>
                           </div>
                           <div className="printPriceInfo">
                              {/*showing on print*/}
                              <p>মোট মূল্য: {invoiceDetails.total_amount}</p>
                              <p className={(invoiceDetails.contact_id === 5) ? 'hide' : ''}
                                 style={{'color': invoiceDetails.due >= 0 ? 'green' : 'red'}}>{invoiceDetails.due >= 0 ? 'বাকী:' : 'অতিরিক্ত:'} {Math.abs(invoiceDetails.due)}</p>
                           </div>
                           <p className="memo">Memo: {invoiceDetails.memo}</p>
                           <p className="text-danger createdBy">Invoice Created
                              By: {invoiceDetails.invoice_created_by}</p>
                           <p className="text-danger createdBy">Invoice Authorized
                              By: {invoiceDetails.authorized_by}</p>
                           <p>Date: {invoiceDetails.created_at}</p>
                           <p>Delivery Time: {invoiceDetails.delivery_time}</p>

                           {/*{after billing}*/}

                           {
                              (invoiceDetails.is_authorized === 1 && invoiceDetails.prepaid_amount > 0) &&
                              < Button onClick={() => this.adjustPaymentFromPrepaid()}>
                                 Clear Due From Advance
                              </Button>
                           }
                           {
                              (invoiceDetails.is_authorized === 1 && invoiceDetails.prepaid_amount <= 0 && invoiceDetails.due > 0) &&
                              <Link className="receiveButton" to={`/sale/saleReceivePayment/${invoiceDetails.id}`}>
                                 <Button block bsStyle="success">Receive Payment</Button>
                              </Link>
                           }

                           {/*{before billing}*/}
                           {!invoiceDetails.is_authorized &&
                           <Link className="receiveButton" to={`/sale/salePrepaidReceive/${invoiceDetails.id}`}>
                              <Button bsStyle="info">Prepaid Receive</Button>
                           </Link>
                           }
                           {
                              !invoiceDetails.is_authorized &&
                              <Button onClick={debounce(this.billAgainstThisInvoice, 400)}>Bill
                                 Against This
                                 Invoice</Button>
                           }

                           {!invoiceDetails.is_authorized &&
                           <Link className="receiveButton" to={`/sale/editSaleForm/${invoiceDetails.id}`}>
                              <Button bsStyle="info">Edit Sale Form</Button>
                           </Link>
                           }

                        </div>
                        <div className="col-md-6">
                           {
                              invoiceDetails.contact_address
                                 ?
                                 <div>
                                    <p>Address: {invoiceDetails.contact_address}</p>
                                    <p>District: {invoiceDetails.district_name}</p>
                                    <p>Thana: {invoiceDetails.thana_name}</p>
                                    <p>Address Type: {invoiceDetails.contact_address_type_name}</p>
                                 </div>
                                 :
                                 <div>
                                    Direct Sale
                                 </div>
                           }
                           <Button className="printButton" block onClick={() => this.printPage()}>Print</Button>
                           <Link className="printButton" target="_blank"
                                 to={`/sale/saleInvoiceDetailOfficialLayout/${invoiceDetails.id}`}>official
                              view</Link>
                           <div>
                              {!invoiceDetails.amount
                              &&
                              <div className="chargeInputSection">
                                 <label>Apply Delivery Change
                                    <input type="checkbox" name="deliveryCharge" checked={this.state.deliveryCharge}
                                           onChange={(e) => this.inputChangeHandler(e)}/>
                                 </label>
                                 <label>Apply Over Weight Charge
                                    <input type="checkbox" name="overWeightCharge" checked={this.state.overWeightCharge}
                                           onChange={(e) => this.inputChangeHandler(e)}/>
                                 </label>
                              </div>
                              }
                           </div>
                           <Button bsStyle="info" onClick={this.sendDetailBySMS}>Send Details By SMS</Button>
                        </div>
                     </div>
               }
               <div className="SaleInvoiceDetail_Nav">
                  <ul className="nav nav-tabs">
                     <li>
                        <IndexLink to={`/sale/saleInvoiceDetail/${invoiceDetails.id}`}
                                   activeStyle={{color: 'red'}}>Items</IndexLink>
                     </li>
                     <li>
                        <Link to={`/sale/saleInvoiceDetail/${invoiceDetails.id}/paymentHistory`}
                              activeStyle={{color: 'red'}}>Payment
                           History</Link>
                     </li>
                  </ul>
               </div>
               {this.props.children}
               <div className="developerInfo">
                  <h2>App Dev: fb.com/fazalrasel, print time:{time}</h2>
                  <h2>mart71.com এর সাথে থাকার জন্য ধন্যবাদ</h2>
               </div>
            </div>
            <hr className="marginNone"/>
            <div className="controls">
               <div>
                  <label>Show Previous Due</label> {" "}
                  <input type="checkbox" name="showPreviousDue" checked={this.state.showPreviousDue}
                         onChange={(e) => this.inputChangeHandler(e)}/>
               </div>

            </div>
            {showPreviousDue && invoiceDetails.otherDueInvoices && invoiceDetails.otherDueInvoices.length > 0 &&
            <div
               className={"oldDueInvoice " + (invoiceDetails.contact_id === 5 ? 'doNotPrintWhenContactIsUnknown' : '')}>
               <h6>আপনার সকল বকেয়া সমুহ:</h6>
               <Table>
                  <thead>
                  <tr>
                     <th>invId</th>
                     <th>Billed</th>
                     <th>জমা</th>
                     <th>বাকী</th>
                     <th className="hideOnPrint">C.S.</th>
                     <th>তারিখ</th>
                     <th className="lastChild">##</th>
                  </tr>
                  </thead>
                  <tbody>
                  {invoiceDetails.otherDueInvoices.map((sale) => (
                     <tr key={sale.id}>
                        <td>{sale.id}</td>
                        <td>{sale.total_amount.toFixed(2)}</td>
                        <td>{sale.total_paid_amount.toFixed(2)}</td>
                        <td>{sale.due.toFixed(2)}</td>
                        <td className="hideOnPrint">{sale.cs}</td>
                        <td>{sale.created_at}</td>
                        <td className="lastChild">
                           <Link target="_blank" to={`/sale/saleInvoiceDetail/${sale.id}`}>Details</Link>
                        </td>
                     </tr>
                  ))}
                  <tr>
                     <td/>
                     <td/>
                     {/*<td className="nameCol" />*/}
                     <td style={{fontSize: '8px'}}>মোট বাকী:</td>
                     <td>{getTotalDue()}</td>
                     <td colSpan={2}/>
                     <td className="lastCol"/>
                  </tr>
                  </tbody>
               </Table>
               <div style={{fontSize: '7px'}}>==বাকী জমা দেওয়ার পর নিজ দায়িত্বে নতুন রশিদ নিন==</div>
            </div>
            }
            {invoiceDetails.contact_id !== 5 &&
            <div className="signature">
               <div>
                  Authority
               </div>
               <div>
                  Received By
               </div>
            </div>
            }
         </div>
      );
   }
}

SaleInvoiceDetail.propTypes = {
   params: PropTypes.object,
   children: PropTypes.object,
   location: PropTypes.object,
};


export default SaleInvoiceDetail;



/** WEBPACK FOOTER **
 ** ./src/components/InvoiceManagement/Sale/SaleInvoiceDetail/SaleInvoiceDetail.js
 **/